/** #################################### Generated content ####################################
 * This block has been generated with deppy create-index (for more information https://github.com/webedx-spark/deppy)
 **/

export { default as TutorialHubPage } from './components/TutorialHubPage';
export { default as TutorialPage } from './components/TutorialPage';
export const TutorialHubPageDynamic = () => import('./components/TutorialHubPage');
export const TutorialPageDynamic = () => import('./components/TutorialPage');

/**
 *  #################################### Generated content ####################################
 **/
